import React from 'react'
import PropTypes from 'prop-types'
import { SkipNavLink, SkipNavContent } from '@reach/skip-nav'
import Navigation from './Navigation'
import Footer from './Footer'

const App = ({ children }) => (
  <React.Fragment>
    <SkipNavLink />
    <Navigation />
    <SkipNavContent />
    <main>{children}</main>
    <Footer />
  </React.Fragment>
)

App.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default App
